export default `(function () {
  function trackAccountCreated() {
    freshpaint.track("welcomevisitConfirmed", {
      url: window.location.href,
    })
  }

  if (window.location.hash === "#wv-confirmed") {
    trackAccountCreated()
  }
  console.log("fired welcomevisitConfirmed event")
})()
`
